import { render } from "./navigatorView.vue?vue&type=template&id=4c43fc7b"
import script from "./navigatorView.vue?vue&type=script&lang=js"
export * from "./navigatorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__